import React, { Component } from 'react';
import { Link } from 'react-router';
import FontAwesome from './FontAwesome';
import Gravatar from 'react-gravatar';
import firebase from 'firebase';

import './NavBar.css';

class NavBar extends Component {
	logout() {
		console.log('logging out');
		firebase.auth().signOut();
		window.FS.identify(false);
	}

  render() {
  	let userMenu = (
  		  <div id="user-menu" className="collapse navbar-collapse">
			  	<ul className="navbar-nav ml-auto">
		  	  	<li className="nav-item">
		  	  	  <Link to="/login" className="nav-link">Log In</Link>
		  	  	</li>
		  	  	<li className="nav-item">
		  	  	  <Link to="/signup" className="nav-link">Sign Up</Link>
		  	  	</li>
		  	  </ul>
	  	  </div>
  	);

  	const { user } = this.props;

  	if (user) {
  		userMenu = (
  		  <div id="user-menu" className="collapse navbar-collapse">
			  	<ul className="navbar-nav ml-auto">
		  	  	<li className="nav-item">
		  	  	  <Link to="/usersettings" className="nav-link" title="Edit profile"><Gravatar className="gravatar" email={user.email} size={28} default="mm" /> {user.displayName ? user.displayName : user.email}</Link>
		  	  	</li>
		  	  	<li className="nav-item">
		  	  	  <Link className="nav-link" onClick={this.logout} title="Log out"><FontAwesome id="logout" name="power-off" /><span className="d-md-none d-lg-none d-xl-none"> Log Out</span></Link>
		  	  	</li>
		  	  </ul>
	  	  </div>
		  );
  	}

    return (
			<nav className="navbar navbar-expand-md fixed-top navbar-dark bg-purple">
				<div className="container">
			    <Link className="navbar-brand" to="/" title="Home"><FontAwesome type="solid" name="address-card"/> Update My Address Book <span className="beta">beta</span></Link>
			    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#user-menu" aria-controls="user-menu" aria-expanded="false" aria-label="Toggle navigation">
			      <FontAwesome name="bars"/>
			    </button>
			    {userMenu}
				</div>
		  </nav>
    );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar.js